import { createContext } from 'react';
import type { DisplaySocket } from './DisplaySocket';
import type { DisplayStore } from './store';

export interface DisplayCtx {
  store: DisplayStore;
  socket: DisplaySocket;
}

export const DisplayContext = createContext<DisplayCtx | null>(null);
